import React from "react";

import { User, CaretDown, SignOut } from "phosphor-react";

import "./header.scss";
import { Dropdown } from "react-bootstrap";
import { getUserInfo } from "utils/common";
import BreadcrumbTrail from "components/common/breadcrumb-trail";
export const LogoutDropdown = ({ logoutHandler }) => (
  <Dropdown className="Dropdown">
    <Dropdown.Toggle variant="" id="">
      <div className="profile-otr">
        <div className="avatar">
          <User size={24} />
        </div>
        <CaretDown size={24} className="caretdown" />
      </div>
    </Dropdown.Toggle>

    <Dropdown.Menu>
      <Dropdown.Item
        href="#"
        onClick={(e) => {
          e.stopPropagation();
          logoutHandler();
        }}
      >
        <SignOut size={24} />
        <span className="ms-2">Logout</span>
      </Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
);
const Header = ({ logoutHandler }) => {
  const user = getUserInfo();
  return (
    <div className="header-main">
      <div className="container-fluid">
        <div className="wrapper">
          <div className="breadcrumb">
            {" "}
            <BreadcrumbTrail />
          </div>
          <div className="d-flex justify-center ">
            <p className="heading-lg" style={{ opacity: 0.6 }}>
              {user?.full_name || ""}
            </p>
            <LogoutDropdown logoutHandler={logoutHandler} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
